import { cn } from '../../lib/utils'

interface FormSelectProps {
  label: string
  name: string
  value: string | undefined
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
  options: { value: string; label: string }[]
  required?: boolean
  disabled?: boolean
  className?: string
}

export function FormSelect({
  label,
  name,
  value,
  onChange,
  options,
  required = false,
  disabled = false,
  className = '',
}: FormSelectProps) {
  return (
    <div className={cn('space-y-1.5', className)}>
      <label htmlFor={name} className="block text-sm font-medium text-neutral-700">
        {label} {required && <span className="text-error-500">*</span>}
      </label>
      <select
        id={name}
        name={name}
        value={value ?? ''}
        onChange={onChange}
        required={required}
        disabled={disabled}
        className="w-full px-3 py-2 text-sm border border-neutral-200 bg-white text-neutral-900 rounded-lg focus:ring-2 focus:ring-primary-500/15 focus:border-primary-500 transition-colors duration-150 hover:border-neutral-300 disabled:bg-neutral-50 disabled:text-neutral-400 disabled:cursor-not-allowed"
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}
